import { IconButton, Badge, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNotifications, useDialog } from "hooks";

export const NotificationButton = () => {
 const { unreadCount } = useNotifications();
 const { openNotifications } = useDialog();

 return (
  <Tooltip title={`${unreadCount} unread notifications`}>
   <IconButton
    color="inherit"
    size="small"
    onClick={openNotifications}
    aria-label={`${unreadCount} unread notifications`}
   >
    <Badge badgeContent={unreadCount} color="error" max={99}>
     <NotificationsIcon />
    </Badge>
   </IconButton>
  </Tooltip>
 );
};
